import { SavedConsentTimestamp } from "types/consent";
import { NULL } from "constants/primitives";

import WidgetConfig from "helpers/init/WidgetConfig";
import isArray from "helpers/isArray";
import isObject from "helpers/isObject";
import createPromise from "helpers/createPromise";
import loadTCFConsentFromStorage from "./loadTCFConsentFromStorage";
import processTCFConsentFromStorage from "./processTCFConsentFromStorage";
import report from "helpers/report";
import TCFsaveLocalTCString from "../TCFsaveLocalTCString";
import isString from "helpers/isString";
import type {
  SavedACString,
  SavedTCFConsent,
  SavedTCString,
} from "../TCFConsentProvider/types";

export const NO_CONSENT_RESPONSE: [null, null, null, null] = [
  NULL,
  NULL,
  NULL,
  NULL,
];

const loadTCFUserConsent = (widgetConfig: WidgetConfig) => {
  return createPromise<LoadTCFUserConsentResponse>((resolve) => {
    // load user tcf consent from storage
    loadTCFConsentFromStorage(widgetConfig).then(
      (storedData) => {
        if (!isArray(storedData)) {
          resolve(NO_CONSENT_RESPONSE);
          return;
        }

        // process user consent after loading it from storage
        const [storedConsent, consentTimestamp, tcString, acString] =
          storedData;
        if (!storedConsent) {
          resolve(NO_CONSENT_RESPONSE);
          return;
        }

        processTCFConsentFromStorage(
          storedConsent,
          consentTimestamp,
          widgetConfig
        ).then(
          (consent) => {
            // no consent, return null
            if (!isObject(consent)) {
              resolve(NO_CONSENT_RESPONSE);
              return;
            }

            if (!isString(tcString)) {
              resolve(NO_CONSENT_RESPONSE);
              return;
            }

            // make sure consent is also saved in all first-party storage locations
            let acStringToPass: SavedACString = NULL;
            if (widgetConfig.acEnabled) {
              acStringToPass = acString;
            }

            TCFsaveLocalTCString(tcString, widgetConfig, acStringToPass);

            resolve([consent, consentTimestamp, tcString, acStringToPass]);
            return;
          },
          () => {
            resolve(NO_CONSENT_RESPONSE);
          }
        );
      },
      (e) => {
        report(e);
        resolve(NO_CONSENT_RESPONSE);
      }
    );
  });
};

export { loadTCFUserConsent };

export type LoadTCFUserConsentResponse = [
  SavedTCFConsent,
  SavedConsentTimestamp,
  SavedTCString,
  SavedACString
];
